/** The web origin of the recording proxy and replay app (spec §19.8), fixed at build time. */
export function webOrigin(): string {
  return ((import.meta.env.VITE_KM_WEB_ORIGIN as string | undefined) || "http://127.0.0.1:8082").replace(/\/$/, "");
}
